import { useLocation, useNavigate } from 'react-router-dom';
import { Home, CalendarDays, Video, User } from 'lucide-react';
import { cn } from '@ui/lib/utils';

const tabs = [
  { path: '/b2c/home', label: '홈', icon: Home },
  { path: '/b2c/daily-summary', label: '하루 요약', icon: CalendarDays },
  { path: '/b2c/videos', label: '녹화 영상', icon: Video },
  { path: '/b2c/mypage', label: 'MY', icon: User },
] as const;

export function BottomNav() {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-40 border-t border-neutral-200 bg-white dark:border-neutral-800 dark:bg-neutral-950"
         style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}>
      <div className="mx-auto flex h-14 max-w-lg items-center justify-around">
        {tabs.map(({ path, label, icon: Icon }) => {
          const isActive = location.pathname === path;
          return (
            <button
              key={path}
              onClick={() => navigate(path)}
              className={cn(
                'relative flex flex-1 flex-col items-center gap-0.5 py-1 text-xs transition-colors',
                isActive
                  ? 'text-[#72734e] dark:text-[#d7d8bd]'
                  : 'text-neutral-400 dark:text-neutral-500',
              )}
            >
              <Icon className="h-5 w-5" />
              <span className="font-medium">{label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
